// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"beSellerModal_wrapper__tFcYy","icon":"beSellerModal_icon__pH2gd","text":"beSellerModal_text__KW4op","actions":"beSellerModal_actions__ftCNB"};